<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container">
      <router-link v-show="user.is_admin" :to="{ name: user ? 'home' : 'welcome' }" class="navbar-brand">
        {{ $t('home') }}
      </router-link>
      <router-link :to="{name: 'carousel'}" class="navbar-brand">
        {{ $t('carousel') }}
      </router-link>
      <router-link :to="{name: 'statistcs.szafy'}" class="navbar-brand">
        {{ $t('szafy') }}
      </router-link>
      <router-link :to="{name: 'statistics.questions'}" class="navbar-brand">
        {{ $t('questions') }}
      </router-link>
      <router-link :to="{name: 'statistics.accessories'}" class="navbar-brand">
        {{ $t('accessories') }}
      </router-link>
      <calendar
        v-model="valueStart"
        show-date-only
        :disabled-days-of-week="disabled"
        :format="format"
        :clear-button="clear"
        :placeholder="placeholderStart"
        :width="widthDate"
      ></calendar>
      <calendar
        v-model="valueEnd"
        show-date-only
        :disabled-days-of-week="disabled"
        :format="format"
        :clear-button="clear"
        :placeholder="placeholderEnd"
        :width="widthDate"
      ></calendar>
      <button type="button" class="btn btn-primary search-btn" @click="searchTime()">{{ $t('search') }}</button>
      <button type="button" class="btn btn-success search-btn" @click="exportStatistic()">{{ $t('export') }}</button>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler"
              aria-controls="navbarToggler" aria-expanded="false">
        <span class="navbar-toggler-icon" />
      </button>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <ul class="navbar-nav">
          <locale-dropdown />
        </ul>

        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle text-dark"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img :src="user.photo_url" class="rounded-circle profile-photo mr-1">
              {{ user.name }}
            </a>
            <div class="dropdown-menu">
              <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3">
                <fa icon="cog" fixed-width />
                {{ $t('settings') }}
              </router-link>

              <div class="dropdown-divider" />
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                <fa icon="sign-out-alt" fixed-width />
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'register' }" class="nav-link" active-class="active">
                {{ $t('register') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>

</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from '../LocaleDropdown'
import Calendar from 'vue2-slot-calendar'

export default {
  components: {
    LocaleDropdown,
    calendar: Calendar
  },

  data: () => ({
    appName: window.config.appName,
    disabled: [],
    valueStart: null,
    valueEnd: new Date(),
    format: "yyyy-MM-dd",
    clear: true,
    widthDate: '150px',
    placeholderStart: "Start Date",
    placeholderEnd: "End Date",
    countDayBeforeCreate: 14
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  created () {
    this.valueStart = new Date()
    this.valueStart.setDate(new Date().getDate() - this.countDayBeforeCreate)
    this.searchTime()
  },

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },

    async searchTime () {
      this.$store.dispatch('statistics/fetchStatistics', {
        'start': this.valueStart,
        'end': this.valueEnd
      })
    },

    exportStatistic () {
      this.$store.dispatch('statistics/exportStatistic', {
        'start': this.valueStart,
        'end': this.valueEnd
      })
    }
  }
}
</script>

<style scoped>
  .profile-photo {
    width: 2rem;
    height: 2rem;
    margin: -.375rem 0;
  }
  .search-btn {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/statistic/StatisticNav.vue